<template>
<div class='hoop1'>

  <img src="img/11.jpg" alt="" preload>
  <img src="img/12.jpg" alt="" preload>
  <img src="img/7.jpg" alt="" preload>
  <img src="img/27.jpg" alt="" preload>
  <img src="img/2.jpg" alt="" preload>
    
</div>

</template>

<script>


export default {
 
    components: {
    
    }
}
</script>

